import React, { FC, Fragment, ReactNode } from "react";

// Mirrors BrandText in the PrOffer Web App — keep the two in sync.

/** Client brand rule for the accented "F" in Foray: italic and orange. */
const FORAY_ACCENT_CLASS = "italic text-primary";
/** DocSubHub: the whole word bold, "Sub" orange. */
const DOCSUBHUB_CLASS = "whitespace-nowrap font-bold";
const DOCSUBHUB_ACCENT_CLASS = "text-primary";

const BRAND_PATTERN = /(\bForay\b|\b[Dd]ocs?[Ss]ub[Hh]ub\b)/g;

/**
 * Renders `text` with every "Foray" (orange italic "F") and "DocSubHub"
 * (bold, orange "Sub") branded per the client's rule. The output is one
 * `<span>` so a flex parent sees a single item and keeps the spaces around
 * the branded words.
 */
const BrandText: FC<{ text: string }> = ({ text }) => {
  const parts: ReactNode[] = text.split(BRAND_PATTERN).map((part, index) => {
    if (part === "Foray") {
      return (
        <span key={index}>
          <span className={FORAY_ACCENT_CLASS}>F</span>oray
        </span>
      );
    }
    if (/^docs?subhub$/i.test(part)) {
      return (
        <span key={index} className={DOCSUBHUB_CLASS} aria-label="DocSubHub">
          Doc<span className={DOCSUBHUB_ACCENT_CLASS}>Sub</span>Hub
        </span>
      );
    }
    return <Fragment key={index}>{part}</Fragment>;
  });

  return <span>{parts}</span>;
};

export default BrandText;
